import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "grid gap-4 sm:grid-cols-1" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "space-y-8 border-t border-slate-100 pt-8" }
const _hoisted_5 = { class: "mb-4 text-base font-bold text-slate-900" }
const _hoisted_6 = { class: "grid gap-5 lg:grid-cols-[1fr_280px]" }
const _hoisted_7 = { class: "space-y-3" }
const _hoisted_8 = { class: "grid gap-3 sm:grid-cols-[8rem_1fr]" }
const _hoisted_9 = { class: "block" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "block" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "block" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "space-y-2" }
const _hoisted_16 = { class: "relative aspect-[4/3] w-full overflow-hidden rounded-lg border border-slate-200 bg-slate-100" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = {
  key: 1,
  class: "flex h-full w-full flex-col items-center justify-center text-slate-400"
}
const _hoisted_19 = {
  key: 2,
  class: "absolute inset-0 flex items-center justify-center bg-white/70 text-sm font-semibold text-slate-700"
}
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = ["onChange"]
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = { class: "space-y-6 border-t border-slate-100 pt-8" }
const _hoisted_24 = { class: "grid gap-6 lg:grid-cols-2" }
const _hoisted_25 = { class: "rounded-lg border border-red-100 bg-red-50/40 p-4 sm:p-5" }
const _hoisted_26 = { class: "grid gap-3" }
const _hoisted_27 = { class: "grid gap-3 sm:grid-cols-[8rem_1fr]" }
const _hoisted_28 = { class: "block" }
const _hoisted_29 = { class: "block" }
const _hoisted_30 = { class: "block" }
const _hoisted_31 = { class: "block" }
const _hoisted_32 = { class: "rounded-lg border border-slate-200 bg-slate-50 p-4 sm:p-5" }
const _hoisted_33 = { class: "grid gap-3" }
const _hoisted_34 = { class: "grid gap-3 sm:grid-cols-[8rem_1fr]" }
const _hoisted_35 = { class: "block" }
const _hoisted_36 = { class: "block" }
const _hoisted_37 = { class: "block" }
const _hoisted_38 = { class: "block" }
const _hoisted_39 = { class: "space-y-5 border-t border-slate-100 pt-8" }
const _hoisted_40 = { class: "block max-w-xl" }
const _hoisted_41 = {
  key: 0,
  class: "rounded-lg border border-dashed border-slate-300 bg-slate-50 p-6 text-center text-sm text-slate-500"
}
const _hoisted_42 = { class: "grid gap-4 sm:grid-cols-2 xl:grid-cols-3" }
const _hoisted_43 = { class: "flex items-center justify-between gap-2" }
const _hoisted_44 = { class: "text-xs font-bold text-slate-500" }
const _hoisted_45 = { class: "flex items-center gap-1" }
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "grid gap-2 sm:grid-cols-[5rem_1fr]" }
const _hoisted_50 = { class: "block" }
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = { class: "block" }
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = { class: "block" }
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = { class: "flex justify-end border-t border-slate-100 pt-6" }

import { computed, reactive, ref, watch } from "vue";
import { useQuery, useMutation, useQueryClient } from "@tanstack/vue-query";
import { useToast } from "vue-toastification";
import AdminPageShell from "@/share/components/admin/AdminPageShell.vue";
import AdminButton from "@/share/components/admin/AdminButton.vue";
import ConfirmarAccionModal from "@/share/components/ConfirmarAccionModal.vue";
import LoadingState from "@/share/components/LoadingState.vue";
import ErrorState from "@/share/components/ErrorState.vue";
import { getGenContenidoNosotrosAction } from "../actions/getGenContenidoNosotros.action";
import { updateGenContenidoNosotrosAction } from "../actions/updateGenContenidoNosotros.action";
import {
  removeTarjetaImagenAction,
  uploadTarjetaImagenAction,
} from "../actions/uploadTarjetaImagen.action";
import type {
  GenContenidoNosotrosPayload,
  MisionVisionPayload,
  NosotrosTarjetaDTO,
  ServicioDTO,
} from "../interfaces/genContenidoNosotros.interface";

type FormTarjeta = NosotrosTarjetaDTO & {
  imagenPreview: string | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ContenidoNosotrosView',
  setup(__props) {

const toast = useToast();
const queryClient = useQueryClient();

const form = reactive<{
  tituloPrincipal: string;
  subtituloPrincipal: string;
  tarjetas: FormTarjeta[];
  misionVision: MisionVisionPayload;
  tituloServicios: string;
  servicios: ServicioDTO[];
}>({
  tituloPrincipal: "",
  subtituloPrincipal: "",
  tarjetas: [
    { orden: 1, titulo: "", texto: "", icono: "", idArchivo: null, imagen: null, imagenPreview: null },
    { orden: 2, titulo: "", texto: "", icono: "", idArchivo: null, imagen: null, imagenPreview: null },
    { orden: 3, titulo: "", texto: "", icono: "", idArchivo: null, imagen: null, imagenPreview: null },
  ],
  misionVision: {
    mision: { titulo: "", icono: "", texto: "", footerLabel: "" },
    vision: { titulo: "", icono: "", texto: "", footerLabel: "" },
  },
  tituloServicios: "Nuestros Servicios",
  servicios: [],
});

const { data, isPending, isError, error, refetch } = useQuery({
  queryKey: ["genContenidoNosotros"],
  queryFn: getGenContenidoNosotrosAction,
  staleTime: 60 * 1000,
});

function syncFromServer(v: GenContenidoNosotrosPayload) {
  form.tituloPrincipal = v.tituloPrincipal;
  form.subtituloPrincipal = v.subtituloPrincipal;
  const sorted = [...v.tarjetas].sort((a, b) => a.orden - b.orden);
  sorted.forEach((t, i) => {
    if (form.tarjetas[i]) {
      form.tarjetas[i].orden = t.orden;
      form.tarjetas[i].titulo = t.titulo;
      form.tarjetas[i].texto = t.texto;
      form.tarjetas[i].icono = t.icono;
      form.tarjetas[i].idArchivo = t.idArchivo ?? null;
      form.tarjetas[i].imagen = t.imagen ?? null;
      form.tarjetas[i].imagenPreview = t.imagen?.url ?? null;
    }
  });
  if (v.misionVision) {
    form.misionVision.mision = { ...v.misionVision.mision };
    form.misionVision.vision = { ...v.misionVision.vision };
  }
  form.tituloServicios = v.tituloServicios?.trim().length
    ? v.tituloServicios
    : "Nuestros Servicios";
  form.servicios = (v.servicios ?? [])
    .slice()
    .sort((a, b) => a.orden - b.orden)
    .map((s) => ({
      orden: s.orden,
      icono: s.icono ?? "",
      titulo: s.titulo ?? "",
      descripcion: s.descripcion ?? "",
    }));
}

function reorderServicios() {
  form.servicios = form.servicios.map((s, i) => ({ ...s, orden: i + 1 }));
}

function addServicio() {
  if (form.servicios.length >= 24) {
    toast.warning("Máximo 24 servicios");
    return;
  }
  form.servicios.push({
    orden: form.servicios.length + 1,
    icono: "🛠️",
    titulo: "Nuevo servicio",
    descripcion: "",
  });
}

const confirmRemoveServicioOpen = ref(false);
const servicioToRemoveIdx = ref<number | null>(null);

function askRemoveServicio(idx: number) {
  servicioToRemoveIdx.value = idx;
  confirmRemoveServicioOpen.value = true;
}

function removeServicio() {
  const idx = servicioToRemoveIdx.value;
  confirmRemoveServicioOpen.value = false;
  servicioToRemoveIdx.value = null;
  if (idx === null || idx < 0) return;
  form.servicios.splice(idx, 1);
  reorderServicios();
}

function moveServicio(idx: number, dir: -1 | 1) {
  const target = idx + dir;
  if (target < 0 || target >= form.servicios.length) return;
  const tmp = form.servicios[idx];
  form.servicios[idx] = form.servicios[target];
  form.servicios[target] = tmp;
  reorderServicios();
}

watch(
  data,
  (v) => {
    if (!v) return;
    syncFromServer(v);
  },
  { immediate: true }
);

const saving = ref(false);

const { mutate: guardar } = useMutation({
  mutationFn: () =>
    updateGenContenidoNosotrosAction({
      tituloPrincipal: form.tituloPrincipal.trim(),
      subtituloPrincipal: form.subtituloPrincipal.trim(),
      tarjetas: form.tarjetas.map((t) => ({
        orden: t.orden,
        titulo: t.titulo.trim(),
        texto: t.texto.trim(),
        icono: t.icono.trim(),
        idArchivo: t.idArchivo ?? null,
      })),
      misionVision: {
        mision: {
          titulo: form.misionVision.mision.titulo.trim(),
          icono: form.misionVision.mision.icono.trim(),
          texto: form.misionVision.mision.texto.trim(),
          footerLabel: form.misionVision.mision.footerLabel.trim(),
        },
        vision: {
          titulo: form.misionVision.vision.titulo.trim(),
          icono: form.misionVision.vision.icono.trim(),
          texto: form.misionVision.vision.texto.trim(),
          footerLabel: form.misionVision.vision.footerLabel.trim(),
        },
      },
      tituloServicios: form.tituloServicios.trim() || "Nuestros Servicios",
      servicios: form.servicios.map((s, i) => ({
        orden: i + 1,
        icono: s.icono.trim(),
        titulo: s.titulo.trim(),
        descripcion: s.descripcion.trim(),
      })),
    }),
  onSuccess: async (payload) => {
    toast.success("Contenido actualizado correctamente");
    syncFromServer(payload);
    await queryClient.invalidateQueries({ queryKey: ["genContenidoNosotros"] });
  },
  onError: (err: unknown) => {
    const msg =
      err && typeof err === "object" && "message" in err
        ? String((err as { message?: string }).message)
        : "No se pudo guardar";
    toast.error(msg);
  },
  onSettled: () => {
    saving.value = false;
  },
});

function onSubmit() {
  saving.value = true;
  guardar();
}

const uploadingOrden = ref<number | null>(null);

async function onPickImage(orden: number, ev: Event) {
  const target = ev.target as HTMLInputElement;
  const file = target.files?.[0];
  if (!file) return;
  if (file.size > 5 * 1024 * 1024) {
    toast.warning("La imagen no puede superar los 5MB");
    target.value = "";
    return;
  }
  if (!/^image\//.test(file.type)) {
    toast.warning("Solo se permiten imágenes");
    target.value = "";
    return;
  }
  uploadingOrden.value = orden;
  try {
    const payload = await uploadTarjetaImagenAction(orden, file);
    syncFromServer(payload);
    toast.success("Imagen actualizada");
    await queryClient.invalidateQueries({ queryKey: ["genContenidoNosotros"] });
  } catch (e: unknown) {
    const msg =
      e && typeof e === "object" && "message" in e
        ? String((e as { message?: string }).message)
        : "No se pudo subir la imagen";
    toast.error(msg);
  } finally {
    uploadingOrden.value = null;
    target.value = "";
  }
}

const confirmRemoveImageOpen = ref(false);
const imageOrdenToRemove = ref<number | null>(null);

function askRemoveImage(orden: number) {
  imageOrdenToRemove.value = orden;
  confirmRemoveImageOpen.value = true;
}

async function onRemoveImage() {
  const orden = imageOrdenToRemove.value;
  confirmRemoveImageOpen.value = false;
  if (orden === null) return;
  uploadingOrden.value = orden;
  try {
    const payload = await removeTarjetaImagenAction(orden);
    syncFromServer(payload);
    toast.success("Imagen eliminada");
    await queryClient.invalidateQueries({ queryKey: ["genContenidoNosotros"] });
  } catch (e: unknown) {
    const msg =
      e && typeof e === "object" && "message" in e
        ? String((e as { message?: string }).message)
        : "No se pudo eliminar la imagen";
    toast.error(msg);
  } finally {
    uploadingOrden.value = null;
    imageOrdenToRemove.value = null;
  }
}

const tarjetaLabels = computed(() => [
  "Tarjeta 1 — Nuestra historia",
  "Tarjeta 2 — Especialización",
  "Tarjeta 3 — Compromiso",
]);

const errorMessage = computed(() =>
  isError.value && error && typeof error === "object" && "message" in error
    ? String((error as { message?: string }).message)
    : null
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminPageShell, {
    title: "Página Nosotros",
    description: "Título, tarjetas con imagen, Misión / Visión y servicios de la página Nosotros en la tienda.",
    "compact-description": false
  }, {
    actions: _withCtx(() => [
      _createVNode(AdminButton, {
        variant: "primary",
        loading: saving.value,
        disabled: _unref(isPending),
        onClick: onSubmit
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
          _createTextVNode(" Guardar cambios ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    default: _withCtx(() => [
      (_unref(isPending))
        ? (_openBlock(), _createBlock(LoadingState, {
            key: 0,
            message: "Cargando contenido…"
          }))
        : (errorMessage.value)
          ? (_openBlock(), _createBlock(ErrorState, {
              key: 1,
              error: { message: errorMessage.value },
              title: "No se pudo cargar el contenido de Nosotros",
              onRetry: _cache[0] || (_cache[0] = ($event: any) => (_unref(refetch)()))
            }, null, 8, ["error"]))
          : (_openBlock(), _createElementBlock("form", {
              key: 2,
              class: "space-y-8 rounded-xl border border-slate-200 bg-white p-5 sm:p-8 shadow-sm",
              onSubmit: _withModifiers(onSubmit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "text-lg font-bold text-slate-900" }, "Encabezado principal", -1)),
                _createElementVNode("label", _hoisted_2, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-sm font-semibold text-slate-700" }, "Título principal", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.tituloPrincipal) = $event)),
                    type: "text",
                    maxlength: "280",
                    class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                  }, null, 512), [
                    [_vModelText, form.tituloPrincipal]
                  ])
                ]),
                _createElementVNode("label", _hoisted_3, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-sm font-semibold text-slate-700" }, "Subtítulo", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.subtituloPrincipal) = $event)),
                    rows: "3",
                    maxlength: "2000",
                    class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                  }, null, 512), [
                    [_vModelText, form.subtituloPrincipal]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "text-lg font-bold text-slate-900" }, "Tarjetas (3)", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.tarjetas, (t, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: t.orden,
                    class: "rounded-lg border border-slate-100 bg-slate-50/80 p-4 sm:p-5"
                  }, [
                    _createElementVNode("h3", _hoisted_5, _toDisplayString(tarjetaLabels.value[idx]), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("label", _hoisted_9, [
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Icono (emoji)", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((form.tarjetas[idx].icono) = $event),
                              type: "text",
                              maxlength: "32",
                              class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-lg shadow-sm"
                            }, null, 8, _hoisted_10), [
                              [_vModelText, form.tarjetas[idx].icono]
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_11, [
                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Título", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((form.tarjetas[idx].titulo) = $event),
                              type: "text",
                              maxlength: "280",
                              class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                            }, null, 8, _hoisted_12), [
                              [_vModelText, form.tarjetas[idx].titulo]
                            ])
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_13, [
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Texto", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((form.tarjetas[idx].texto) = $event),
                            rows: "6",
                            maxlength: "8000",
                            class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                          }, null, 8, _hoisted_14), [
                            [_vModelText, form.tarjetas[idx].texto]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "block text-xs font-medium text-slate-600" }, "Imagen de la tarjeta", -1)),
                        _createElementVNode("div", _hoisted_16, [
                          (t.imagenPreview)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: t.imagenPreview,
                                alt: t.titulo,
                                class: "h-full w-full object-cover"
                              }, null, 8, _hoisted_17))
                            : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("svg", {
                                  class: "h-10 w-10 mb-2",
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "1.6",
                                    d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14M4 6h16M4 6v12a2 2 0 002 2h12a2 2 0 002-2V6M4 6a2 2 0 012-2h12a2 2 0 012 2"
                                  })
                                ], -1),
                                _createElementVNode("span", { class: "text-xs" }, "Sin imagen", -1)
                              ]))])),
                          (uploadingOrden.value === t.orden)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Procesando… "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["inline-flex flex-1 cursor-pointer items-center justify-center gap-2 rounded-lg bg-slate-900 px-3 py-2 text-xs font-semibold text-white hover:bg-slate-800", { 'pointer-events-none opacity-60': uploadingOrden.value === t.orden }])
                          }, [
                            _cache[22] || (_cache[22] = _createTextVNode(" Subir / cambiar ", -1)),
                            _createElementVNode("input", {
                              type: "file",
                              class: "hidden",
                              accept: "image/png,image/jpeg,image/jpg,image/webp,image/gif",
                              onChange: ($event: any) => (onPickImage(t.orden, $event))
                            }, null, 40, _hoisted_21)
                          ], 2),
                          (t.imagen)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "rounded-lg border border-red-200 bg-white px-3 py-2 text-xs font-semibold text-red-600 hover:bg-red-50 disabled:opacity-50",
                                disabled: uploadingOrden.value === t.orden,
                                onClick: ($event: any) => (askRemoveImage(t.orden))
                              }, " Quitar ", 8, _hoisted_22))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-[11px] text-slate-500" }, " JPG/PNG/WEBP/GIF, máx. 5 MB. Se sube al storage MinIO. ", -1))
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[36] || (_cache[36] = _createElementVNode("h2", { class: "text-lg font-bold text-slate-900" }, "Misión & Visión", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "mb-4 text-base font-bold text-red-700" }, "Misión", -1)),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Icono", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.misionVision.mision.icono) = $event)),
                            type: "text",
                            maxlength: "32",
                            class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-lg shadow-sm"
                          }, null, 512), [
                            [_vModelText, form.misionVision.mision.icono]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_29, [
                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Título", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.misionVision.mision.titulo) = $event)),
                            type: "text",
                            maxlength: "120",
                            class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                          }, null, 512), [
                            [_vModelText, form.misionVision.mision.titulo]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_30, [
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Texto", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.misionVision.mision.texto) = $event)),
                          rows: "6",
                          maxlength: "8000",
                          class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                        }, null, 512), [
                          [_vModelText, form.misionVision.mision.texto]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_31, [
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, " Etiqueta de pie (ej. \"Nuestro Propósito\") ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.misionVision.mision.footerLabel) = $event)),
                          type: "text",
                          maxlength: "120",
                          class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                        }, null, 512), [
                          [_vModelText, form.misionVision.mision.footerLabel]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[35] || (_cache[35] = _createElementVNode("h3", { class: "mb-4 text-base font-bold text-slate-900" }, "Visión", -1)),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("label", _hoisted_35, [
                          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Icono", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.misionVision.vision.icono) = $event)),
                            type: "text",
                            maxlength: "32",
                            class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-lg shadow-sm"
                          }, null, 512), [
                            [_vModelText, form.misionVision.vision.icono]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_36, [
                          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Título", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.misionVision.vision.titulo) = $event)),
                            type: "text",
                            maxlength: "120",
                            class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                          }, null, 512), [
                            [_vModelText, form.misionVision.vision.titulo]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_37, [
                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Texto", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.misionVision.vision.texto) = $event)),
                          rows: "6",
                          maxlength: "8000",
                          class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                        }, null, 512), [
                          [_vModelText, form.misionVision.vision.texto]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_38, [
                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, " Etiqueta de pie (ej. \"Nuestro Futuro\") ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.misionVision.vision.footerLabel) = $event)),
                          type: "text",
                          maxlength: "120",
                          class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                        }, null, 512), [
                          [_vModelText, form.misionVision.vision.footerLabel]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", { class: "flex flex-wrap items-center justify-between gap-3" }, [
                  _cache[38] || (_cache[38] = _createElementVNode("h2", { class: "text-lg font-bold text-slate-900" }, "Nuestros Servicios", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "inline-flex items-center gap-2 rounded-lg bg-slate-900 px-3 py-2 text-xs font-semibold text-white hover:bg-slate-800",
                    onClick: addServicio
                  }, [...(_cache[37] || (_cache[37] = [
                    _createElementVNode("span", { class: "text-base leading-none" }, "+", -1),
                    _createTextVNode(" Añadir servicio ", -1)
                  ]))])
                ]),
                _createElementVNode("label", _hoisted_40, [
                  _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-xs font-medium text-slate-600" }, "Título de la sección", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.tituloServicios) = $event)),
                    type: "text",
                    maxlength: "280",
                    class: "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm shadow-sm"
                  }, null, 512), [
                    [_vModelText, form.tituloServicios]
                  ])
                ]),
                (form.servicios.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, " No hay servicios. Usa \"Añadir servicio\" para comenzar. "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_42, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.servicios, (s, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "flex flex-col gap-3 rounded-lg border border-slate-200 bg-slate-50/60 p-4"
                    }, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, "#" + _toDisplayString(idx + 1), 1),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded p-1 text-slate-500 hover:bg-slate-200 disabled:opacity-30",
                            disabled: idx === 0,
                            title: "Mover arriba",
                            onClick: ($event: any) => (moveServicio(idx, -1))
                          }, " ↑ ", 8, _hoisted_46),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded p-1 text-slate-500 hover:bg-slate-200 disabled:opacity-30",
                            disabled: idx === form.servicios.length - 1,
                            title: "Mover abajo",
                            onClick: ($event: any) => (moveServicio(idx, 1))
                          }, " ↓ ", 8, _hoisted_47),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ml-1 rounded border border-red-200 bg-white px-2 py-1 text-[11px] font-semibold text-red-600 hover:bg-red-50",
                            onClick: ($event: any) => (askRemoveServicio(idx))
                          }, " Eliminar ", 8, _hoisted_48)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("label", _hoisted_50, [
                          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-[11px] font-medium text-slate-600" }, "Icono", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((form.servicios[idx].icono) = $event),
                            type: "text",
                            maxlength: "32",
                            class: "mt-1 w-full rounded-lg border border-slate-300 px-2 py-1.5 text-lg shadow-sm"
                          }, null, 8, _hoisted_51), [
                            [_vModelText, form.servicios[idx].icono]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_52, [
                          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-[11px] font-medium text-slate-600" }, "Título", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((form.servicios[idx].titulo) = $event),
                            type: "text",
                            maxlength: "120",
                            class: "mt-1 w-full rounded-lg border border-slate-300 px-2 py-1.5 text-sm shadow-sm"
                          }, null, 8, _hoisted_53), [
                            [_vModelText, form.servicios[idx].titulo]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_54, [
                        _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-[11px] font-medium text-slate-600" }, "Descripción", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": ($event: any) => ((form.servicios[idx].descripcion) = $event),
                          rows: "3",
                          maxlength: "2000",
                          class: "mt-1 w-full rounded-lg border border-slate-300 px-2 py-1.5 text-sm shadow-sm"
                        }, null, 8, _hoisted_55), [
                          [_vModelText, form.servicios[idx].descripcion]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createVNode(AdminButton, {
                  variant: "primary",
                  type: "submit",
                  loading: saving.value
                }, {
                  default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                    _createTextVNode(" Guardar cambios ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32)),
      _createVNode(ConfirmarAccionModal, {
        show: confirmRemoveImageOpen.value,
        title: "Quitar imagen",
        message: "¿Quitar la imagen de esta tarjeta?",
        "confirm-label": "Sí, quitar",
        "cancel-label": "Cancelar",
        variant: "danger",
        loading: uploadingOrden.value !== null,
        onCancel: _cache[12] || (_cache[12] = ($event: any) => (confirmRemoveImageOpen.value = false)),
        onConfirm: onRemoveImage
      }, null, 8, ["show", "loading"]),
      _createVNode(ConfirmarAccionModal, {
        show: confirmRemoveServicioOpen.value,
        title: "Eliminar servicio",
        message: "¿Eliminar este servicio? Esta acción no se puede deshacer desde aquí.",
        "confirm-label": "Sí, eliminar",
        "cancel-label": "Cancelar",
        variant: "danger",
        onCancel: _cache[13] || (_cache[13] = ($event: any) => (confirmRemoveServicioOpen.value = false)),
        onConfirm: removeServicio
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})